import { Tabs, Tab, Box } from '@mui/material';
import {
  PREDICTION_CATEGORIES,
  CATEGORY_LABELS,
  PredictionCategory,
} from '../../Predictions/constants/categories';
import { PairStatsByCategory } from '../api/usePairMapper';

export const HISTORY_TAB = '__history__' as const;
export type MapperTabValue = PredictionCategory | typeof HISTORY_TAB;

interface Props {
  value: MapperTabValue;
  onChange: (value: MapperTabValue) => void;
  stats?: PairStatsByCategory;
}

const TAB_SX = {
  minHeight: 36,
  py: 0,
  textTransform: 'none' as const,
  fontSize: '0.85rem',
};

export const CategoryTabs = ({ value, onChange, stats }: Props) => {
  return (
    <Tabs
      value={value}
      onChange={(_, v) => onChange(v)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        minHeight: 36,
        '& .MuiTabs-indicator': { height: 2 },
      }}
    >
      {PREDICTION_CATEGORIES.map((cat) => {
        const count = stats?.byCategory?.[cat]?.total ?? 0;
        return (
          <Tab
            key={cat}
            value={cat}
            sx={TAB_SX}
            label={
              <Box component="span">
                {CATEGORY_LABELS[cat]}{' '}
                <Box
                  component="span"
                  sx={{ opacity: 0.6, fontSize: '0.8em', ml: 0.25 }}
                >
                  ({count})
                </Box>
              </Box>
            }
          />
        );
      })}
      <Tab value={HISTORY_TAB} label="History" sx={TAB_SX} />
    </Tabs>
  );
};
